/* eslint-disable */

/** select columns of table "argo.material_assembly" */
export enum ArgoMaterialAssemblySelectColumn {
  /** column name */
  AssemblyMaterialId = 'assembly_material_id',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  ComponentMaterialId = 'component_material_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataElementId = 'data_element_id',
  /** column name */
  MaterialMarriageId = 'material_marriage_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Status = 'status',
  /** column name */
  StatusNote = 'status_note'
}

